/* unplugin-vue-components disabled */import script from "./navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar.vue?vue&type=script&setup=true&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=419b713d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419b713d"]])

export default __exports__